<template>
  <div class="v-sheet theme--light">
    <h2 class="text-xs-center mb-4" v-if="text">{{ text }}</h2>
    <div class="hvh-relative">
      <hvh-chart :visualization="visualization" :options="chartOptions" :isEditMode="true" :height="height" @item-clicked="$emit('checked-changed', $event, data)" @wheel="scroll" />
      <hvh-scroll-bar :total="data.length" :displayed="displayedBarChartData" v-model="scrollBarValue" v-if="displayedBarChartData && data.length > displayedBarChartData" />
      <loader v-if="isFiltering" />
    </div>
  </div>
</template>
  
<script>
import { Debouncer, hashCode } from '../../../libraries/common';
export default {
  props: ['data', 'filterObject', 'text', 'isChecked', 'nameField', 'valueField', 'options', 'isFiltering', 'height', 'displayedBarChartData'],
  data() {
    return {
      scrollBarValue: 0,
      chartOptions: this.options,
      debouncer: new Debouncer(2000),
    }
  },
  methods: {
    scroll(event) {
      if (this.displayedBarChartData) {
        var oldValue = this.scrollBarValue;
        this.scrollBarValue += event.wheelDeltaY < 0 ? 1 : -1;
        this.scrollBarValue = Math.max(0, Math.min(this.scrollBarValue, this.data.length - this.displayedBarChartData));
        if (Math.abs(oldValue - this.scrollBarValue) > 0) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    },
  },
  computed: {
    visualization() {
      var dataLength = Math.min(this.data.length, (this.displayedBarChartData || this.data.length));
      return {
        visualization_type: 'barchart',
        name_field: this.nameField || 'diagnosis',
        value_field: this.valueField || 'totalpatients',
        data: this.data
          .filter((_, ind) => ind >= this.scrollBarValue && ind < this.scrollBarValue + dataLength)
          .map(f => ({ ...f, unchecked: this.isChecked && this.data.find(f => this.isChecked(f)) && !this.isChecked(f) })),
      };
    },
    filterHash() {
      return hashCode(this.filterObject || {});
    }
  },
  watch: {
    filterHash() {
      this.debouncer.clear().push(() => this.$emit('refresh-data', this.filterObject));
    },
  },
  mounted() {
    this.$emit('chart-created', this.filterObject);
  }
}
</script>
